"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryClientProvider = exports.QueryClient = exports.hello = void 0;
exports.hello = () => {
    return 'This is coming from shared folder noice right!!';
};
const react_query_1 = require("react-query");
Object.defineProperty(exports, "QueryClient", { enumerable: true, get: function () { return react_query_1.QueryClient; } });
Object.defineProperty(exports, "QueryClientProvider", { enumerable: true, get: function () { return react_query_1.QueryClientProvider; } });
__exportStar(require("./types/AuthTypes"), exports);
__exportStar(require("./model/BF/Section1FormModel"), exports);
__exportStar(require("./model/BF/Section2FormModel"), exports);
__exportStar(require("./model/BF/Section3FormModel"), exports);
__exportStar(require("./model/BF/Section4FormModel"), exports);
__exportStar(require("./stores/CredentialStore"), exports);
__exportStar(require("./stores/getPatientStore"), exports);
__exportStar(require("./stores/SnackbarStore"), exports);
__exportStar(require("./stores/DoctorDetailsStore"), exports);
__exportStar(require("./stores/TabStateStore"), exports);
__exportStar(require("./schema/BlackFungus/FormInitialValues"), exports);
__exportStar(require("./providers/AuthProvider"), exports);
__exportStar(require("./providers/BlackFungus/BFSection1Provider"), exports);
__exportStar(require("./providers/HomeDashboard/DashboardProvider"), exports);
//# sourceMappingURL=index.js.map